import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Mail, 
  FileText, 
  Shield, 
  Briefcase, 
  Users, 
  Home, 
  Heart,
  BookOpen,
  Stethoscope,
  Code,
  Wrench,
  Building2,
  Car,
  GraduationCap,
  Cookie,
  UtensilsCrossed,
  Truck
} from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-babyblue-800 text-white mt-16 pt-8">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <h3 className="font-heading text-2xl font-extrabold text-white mb-2">Germanatic</h3>
            <p className="text-sm text-babyblue-300 font-medium mb-4">German for Integration & Careers</p>
            <p className="text-babyblue-300 text-sm">
              Your complete path to professional success and integration in Germany.
            </p>
          </div>

          {/* Grammar */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4 flex items-center gap-2">
              <BookOpen className="w-4 h-4 text-babyblue-300" />
              Grammar
            </h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/grammar?level=A1" className="text-babyblue-300 hover:text-white transition-colors">A1 - Beginner</Link></li>
              <li><Link to="/grammar?level=A2" className="text-babyblue-300 hover:text-white transition-colors">A2 - Elementary</Link></li>
              <li><Link to="/grammar?level=B1" className="text-babyblue-300 hover:text-white transition-colors">B1 - Intermediate</Link></li>
              <li><Link to="/grammar?level=B2" className="text-babyblue-300 hover:text-white transition-colors">B2 - Upper Intermediate</Link></li>
              <li><Link to="/grammar?level=C1" className="text-babyblue-300 hover:text-white transition-colors">C1 - Advanced</Link></li>
              <li><Link to="/grammar?level=C2" className="text-babyblue-300 hover:text-white transition-colors">C2 - Mastery</Link></li>
            </ul>
          </div>

          {/* Career Paths */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4 flex items-center gap-2">
              <Briefcase className="w-4 h-4 text-babyblue-300" />
              Career Paths
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/careers/healthcare" className="text-babyblue-300 hover:text-white transition-colors flex items-center gap-2">
                  <Stethoscope className="w-3 h-3" /> Healthcare
                </Link>
              </li>
              <li>
                <Link to="/careers/it" className="text-babyblue-300 hover:text-white transition-colors flex items-center gap-2">
                  <Code className="w-3 h-3" /> IT & Technology
                </Link>
              </li>
              <li>
                <Link to="/careers/engineering" className="text-babyblue-300 hover:text-white transition-colors flex items-center gap-2">
                  <Wrench className="w-3 h-3" /> Engineering
                </Link>
              </li>
              <li>
                <Link to="/careers/business" className="text-babyblue-300 hover:text-white transition-colors flex items-center gap-2">
                  <Building2 className="w-3 h-3" /> Business
                </Link>
              </li>
              <li>
                <Link to="/careers/hospitality" className="text-babyblue-300 hover:text-white transition-colors flex items-center gap-2">
                  <UtensilsCrossed className="w-3 h-3" /> Hospitality
                </Link>
              </li>
              <li>
                <Link to="/careers/logistics" className="text-babyblue-300 hover:text-white transition-colors flex items-center gap-2">
                  <Truck className="w-3 h-3" /> Logistics
                </Link>
              </li>
            </ul>
          </div>

          {/* Integration */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4 flex items-center gap-2">
              <Users className="w-4 h-4 text-babyblue-300" />
              Integration
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/integration/visa" className="text-babyblue-300 hover:text-white transition-colors flex items-center gap-2">
                  <FileText className="w-3 h-3" /> Visa & Immigration
                </Link>
              </li>
              <li>
                <Link to="/integration/housing" className="text-babyblue-300 hover:text-white transition-colors flex items-center gap-2">
                  <Home className="w-3 h-3" /> Finding Housing
                </Link>
              </li>
              <li>
                <Link to="/integration/healthcare-system" className="text-babyblue-300 hover:text-white transition-colors flex items-center gap-2">
                  <Heart className="w-3 h-3" /> Healthcare System
                </Link>
              </li>
              <li>
                <Link to="/integration/education" className="text-babyblue-300 hover:text-white transition-colors flex items-center gap-2">
                  <GraduationCap className="w-3 h-3" /> Education & Training
                </Link>
              </li>
              <li>
                <Link to="/integration/business-setup" className="text-babyblue-300 hover:text-white transition-colors flex items-center gap-2">
                  <Briefcase className="w-3 h-3" /> Opening a Business
                </Link>
              </li>
              <li>
                <Link to="/integration/fuhrerschein" className="text-babyblue-300 hover:text-white transition-colors flex items-center gap-2">
                  <Car className="w-3 h-3" /> Driver's License
                </Link>
              </li>
              <li>
                <Link to="/integration/daily-life" className="text-babyblue-300 hover:text-white transition-colors flex items-center gap-2">
                  <Users className="w-3 h-3" /> Daily Life & Culture
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/reviews" className="text-babyblue-300 hover:text-white transition-colors">
                  Success Stories
                </Link>
              </li>
              <li>
                <Link to="/contact" className="flex items-center gap-2 text-babyblue-300 hover:text-white transition-colors">
                  <Mail className="w-4 h-4" />
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/impressum" className="flex items-center gap-2 text-babyblue-300 hover:text-white transition-colors">
                  <FileText className="w-4 h-4" />
                  Impressum / Legal Notice
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className="flex items-center gap-2 text-babyblue-300 hover:text-white transition-colors">
                  <Shield className="w-4 h-4" />
                  Datenschutz / Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" className="flex items-center gap-2 text-babyblue-300 hover:text-white transition-colors">
                  <FileText className="w-4 h-4" />
                  Haftungsausschluss / Disclaimer
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => window.dispatchEvent(new Event('open-cookie-settings'))}
                  className="flex items-center gap-2 text-babyblue-300 hover:text-white transition-colors text-left"
                  data-testid="footer-cookie-settings"
                >
                  <Cookie className="w-4 h-4" />
                  Cookie-Einstellungen / Cookie settings
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-babyblue-700 mt-12 pt-10 text-center text-sm text-babyblue-400">
          <p>
            © {new Date().getFullYear()} Germanatic. Helping professionals integrate into Germany.
          </p>
          <p className="text-xs text-babyblue-500 mt-2">
            <Link to="/disclaimer" className="hover:text-white transition-colors">
              Alle Angaben sind ohne Gewähr. / All information is provided without warranty.
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
